export default {
  PaletteFooter: {
    backgroundColor: 'white',
    height: '5vh',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    fontWeight: 'bold',
    color: 'rgba(0,0,0,0.7)',
  },
  emoji: {
    fontSize: '1.5rem',
    margin: '0 1rem',
  },
}
